import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var AdminDepartmentListRes;
export const AdminDepartmentListTodo = createAsyncThunk('AdminDepartmentList', async (data) => {


    try {
        const res = await axios({
            method: "get",
            url: process.env.REACT_APP_API_URL + 'admin/department_admin',
            params: {
                "company_id": localStorage.getItem('companyId')
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') },

        })
        return AdminDepartmentListRes = res.data

    } catch (error) {
        return AdminDepartmentListRes = error.response.data
    }
});

const AdminDepartmentListSlice = createSlice({
    name: 'AdminDepartmentList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(AdminDepartmentListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(AdminDepartmentListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default AdminDepartmentListSlice.reducer; 